<template>
  <div :class="classeRaiz" class="box-leilao" @click="click(leilao)" style="cursor: pointer">
    <div class="auction-item-2">
      <div class="auction-thumb border-radius-5 thumb-height-247">
        <img :src="leilao.fotoUrl" :title="leilao.titulo" />
        <span class="tag">LEILÃO PARCEIRO</span>
      </div>
      <div class="field-badge">
        <span class="badge badge-gray bg-secondary w-100"
          v-if="leilao.tipoLeilao && leilao.tipoLeilao.toUpperCase() == 'JUDICIAL'">JUDICIAL</span>
        <span class="badge badge-yellow bg-secondary w-100"
          v-if="leilao.tipoLeilao && leilao.tipoLeilao.toUpperCase() == 'EXTRAJUDICIAL'">EXTRAJUDICIAL</span>
        <span class="badge badge-orange bg-secondary w-100"
          v-if="leilao.tipoLeilao && leilao.tipoLeilao.toUpperCase() == 'VENDA DIRETA'">VENDA DIRETA</span>
      </div>
      <div class="auction-content">
        <div class="title-adress text-center">
          <h6 class="title mb-1 px-2 w-100 text-truncate">
            {{ leilao.titulo }}
          </h6>
          <p class="titulo-leilao">{{ leilao.subTitulo }}</p>
        </div>
      </div>
    </div>
    <div class="information">
      <div class="text" v-if="leilao.pracas && leilao.pracas.length > 1">
        <ul>
          <li v-for="(praca, index) in leilao.pracas" :key="index" class="pb-2 leilao-aberto">
            <strong>{{ index + 1 }}º LEILÃO: </strong>{{ formatarDataHora(praca) }}
            <br />
            <span v-if="leilao.valores && leilao.valores[index]">
              <strong>LANCE INICIAL: </strong>
              {{
                leilao.valores[index]
                | currency('R$', 2, {
                  spaceBetweenAmountAndSymbol: true,
                  decimalSeparator: ',',
                  thousandsSeparator: '.'
                })
              }}
            </span>
          </li>
        </ul>
      </div>
      <div v-else>
        <ul>
          <li>
            <strong>DATA: </strong>{{ leilao.pracas && leilao.pracas[0] ? formatarDataHora(leilao.pracas[0]) : '-' }}
          </li>
          <li><strong>CATEGORIA: </strong>{{ leilao.categoria }}</li>
          <li><strong>Nº LOTES: </strong>{{ leilao.qtdLotes }}</li>
        </ul>
      </div>
    </div>
    <div class="detail-button">
      <a href="javascript:void(0)" class="custom-button detail" :class="{
        'box-pulse-yellow': leilao.status === 'Em Andamento' || leilao.status === 'Em Pregão',
        'status-cancelado': leilao.status === 'Cancelado',
        'status-encerrado': leilao.status === 'Encerrado' || leilao.status === 'Fechado' || leilao.status === 'Suspenso'
      }">
        <span v-if="leilao.status === 'Aberto' || leilao.status === 'Agendado'">ABERTO</span>
        <span v-else-if="leilao.status === 'Em Andamento' || leilao.status === 'Em Pregão'">EM PREGÃO</span>
        <span v-else-if="leilao.status === 'Cancelado'">CANCELADO</span>
        <span v-else-if="leilao.status === 'Suspenso'">SUSPENSO</span>
        <span v-else-if="leilao.status === 'Fechado' || leilao.status === 'Encerrado'">ENCERRADO</span>
        <span v-else>EM BREVE</span>
      </a>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import { mapActions } from 'vuex';

moment.locale('pt-br');

export default {
  props: {
    classeRaiz: {
      type: String
    },
    leilao: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      colorPrimary: process.env.VUE_APP_PRIMARY_COLOR,
      colorSecondary: process.env.VUE_APP_SECONDARY_COLOR,
      colorConstrast: process.env.VUE_APP_CONSTRAST_COLOR
    };
  },
  methods: {
    ...mapActions(['clickLeilaoParceiro']),
    click(leilao) {
      this.clickLeilaoParceiro(leilao.leilaoParceiroId);
      window.open(leilao.url);
    },
    formatarDataHora(value) {
      return moment.utc(value).local().format('DD/MM/YYYY [às] HH:mm');
    }
  },
};
</script>

<style scoped>
.tag {
  background-color: #45bcbcf0;
  color: #fff;
  font-size: 10px;
  font-weight: bold;
  position: absolute;
  top: 10px;
  right: 10px;
  padding: 0px 15px;
  border-radius: 15px;
}

.leilao-aberto {
  color: #52606d !important;
}

.status-cancelado {
  background-color: #999 !important;
}

.status-encerrado {
  background-color: #303030 !important;
}

.detail-button a {
  background-color: #3de32a;
}

.titulo-leilao {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  padding: 0px 10px;
  font-size: 12px;
  margin: 0;
}

.box-leilao {
  position: relative;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;
  margin-top: 30px;
}

.title-adress {
  display: flex;
  align-items: center;
  text-align: center;
  height: 120px;
  background-color: #098475;
  border-radius: 0px 0px 20px 20px;
  justify-content: center;
  flex-direction: column;
  padding-top: 10px;
}

.title-adress,
h6 {
  color: white;
}

.title-adress,
p {
  color: white;
}

.field-badge {
  width: 100%;
  position: absolute;
  top: 187px;
}

.badge {
  display: flex;
  border-radius: 15px;
  height: 35px;
  font-size: 100%;
  justify-content: center;
  align-items: center;
}

.badge-gray {
  background-color: #d9d9d9 !important;
}

.badge-yellow {
  background-color: #fdff83 !important;
}

.badge-orange {
  background-color: #f1d8a9 !important;
}

.information {
  margin: 0 auto 0px;
  border: 1px solid rgb(218, 218, 218);
  border-top: 0px;
  border-bottom: 0;
  text-align: left;
  flex: 1 1;
  padding: 20px 15px 60px 15px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.detail-button {
  margin: 0 auto;
  width: 100%;
  position: absolute;
  left: 0;
  padding: 0 15px;
  bottom: 0px;
}

.auction-item-2 .auction-thumb {
  height: 200px;
  max-height: 200px;
  padding: 0;
  margin: 0;
  background-color: #fff;
  position: relative;
}

.auction-thumb img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
}

.text {
  font-size: 12px;
  color: #52606da1 !important;
}

.text ul li {
  padding: 0;
}

.detail {
  width: 100% !important;
  text-align: center;
  background-color: v-bind(colorPrimary);
  color: v-bind(colorConstrast);
}

.box-pulse-yellow {
  border: 2px solid #f9c718 !important;
  box-shadow: 0 0 0 0 rgba(249, 199, 24, 1);
  animation: pulse-yellow 1.5s infinite;
  background-color: #f7d663 !important;
}

@keyframes pulse-yellow {
  0% {
    box-shadow: 0 0 0 0 rgba(249, 199, 24, 0.7);
  }

  70% {
    box-shadow: 0 0 0 10px rgba(249, 199, 24, 0);
  }

  100% {
    box-shadow: 0 0 0 0 rgba(249, 199, 24, 0);
  }
}
</style>
